module.exports = __webpack_public_path__ + "static/media/javascript.037f2a06.svg";